module.exports = __webpack_public_path__ + "img/np.be4ae186.svg";